import i18next from 'i18next';

const flattenObject = (
  obj: Record<string, unknown>,
  prefix = '',
): Record<string, string> =>
  Object.entries(obj).reduce<Record<string, string>>((acc, [key, value]) => {
    const flatKey = prefix ? `${prefix}.${key}` : key;

    if (value && typeof value === 'object' && !Array.isArray(value)) {
      Object.assign(
        acc,
        flattenObject(value as Record<string, unknown>, flatKey),
      );
    } else {
      acc[flatKey] = String(value);
    }

    return acc;
  }, {});

const updateTranslations = (
  translations: object,
  ns = 'translation',
  language = '',
) => {
  const currentLanguage = i18next.language;
  const flatTranslations = flattenObject(
    translations as Record<string, unknown>,
  );

  i18next.addResourceBundle(
    language || currentLanguage,
    ns,
    flatTranslations,
    true,
    true,
  );

  return i18next.changeLanguage(currentLanguage);
};

export { flattenObject };
export default updateTranslations;
